import { Module, Mutation, VuexModule, Action } from "vuex-module-decorators";
import { cloneDeep } from "lodash-es";
import { formatProductData } from "@/utils/mall/mall";
import { GTGroupFixedParam, GTGroupFixedOrgParam } from "@/enums/app";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import {
  getCartSkuAmount,
  calculateCart,
  calculateCartWT,
  addCart,
  updateCartSku,
  updateCartSkuList,
  deleteCartBySelected,
  checkOutCartWt,
  clearCartOffSale
} from "@/graphql/cart.gql";
import { OrderExpressTypeEnums } from "@/enums/mall";

export interface MallShoppingCartState {
  cartNumber: number;
  cartPopup: boolean;
  listData: any[];
  listDataJT: any[];
  listDataJXS: any[];
  storeInfo: any;
  skuExpressMap: any;
}

export interface MallSku {
  count: number;
  skuCode: string;
  selectFlag?: string;
  storeCode: string;
  cartType: string;
}
export interface CartPriceMap {
  actualPrice?: number;
  productAmount?: number;
  discount?: number;
}

@Module({ name: "MallShoppingCartModule", namespaced: true })
export default class MallShoppingCartModule
  extends VuexModule<MallShoppingCartState, RootState>
  implements MallShoppingCartState {
  // 购物车数量
  cartNumber: number = 0;
  // 弹窗
  cartPopup: boolean = false;
  // 购物车价格集合
  cartPriceMap: CartPriceMap = {};
  // 合计总价
  totalPrice: number = 0;
  // 优惠金额
  discountPrice: number = 0;
  // 列表数据
  listData: any[] = [];

  listDataJT: any[] = [];
  listDataJXS: any[] = [];
  // 失效商品
  invalidListData: any[] = [];

  // 全选
  allSelect: boolean = false;

  allSelectJT: boolean = false;
  allSelectJXS: boolean = false;

  // 店铺信息
  storeInfo: object = {};
  // 结算信息
  settleData: any[] = [];
  settleDataJXS: any[] = [];
  // sku是否支持快递映射表
  skuExpressMap: any = {};

  // 需要快递商品
  get expressListData() {
    return this.listData.filter(o => o._needExpress);
  }
  // 不需要快递的商品
  get notExpressListData() {
    return this.listData.filter(o => !o._needExpress);
  }

  @Mutation
  saveCartPriceMapMutation(data: CartPriceMap | undefined | null) {
    this.cartPriceMap = data ?? {};
  }
  @Mutation
  saveCartNumberMutation(data: number | undefined | null) {
    this.cartNumber = data ?? 0;
  }
  @Mutation
  saveCartPopupMutation(data: boolean | undefined) {
    this.cartPopup = data ?? false;
  }

  //
  @Mutation
  saveListDataMutation(data) {
    this.listData = data ?? [];
  }

  @Mutation
  saveListDataJTMutation(data) {
    this.listDataJT = data ?? [];
  }
  @Mutation
  saveListDataJXSMutation(data) {
    this.listDataJXS = data ?? [];
  }

  //
  @Mutation
  saveInvalidListDataMutation(data) {
    console.log(data);
    this.invalidListData = data ?? [];
  }

  //
  @Mutation
  saveAllSelectMutation(data: boolean | undefined) {
    this.allSelect = data ?? false;
  }
  @Mutation
  saveAllSelectJTMutation(data: boolean | undefined) {
    this.allSelectJT = data ?? false;
  }
  @Mutation
  saveAllSelectJXSMutation(data: boolean | undefined) {
    this.allSelectJXS = data ?? false;
  }
  //
  @Mutation
  saveStoreInfoMutation(data: object | undefined) {
    this.storeInfo = data ?? {};
  }
  @Mutation
  saveSettleDataMutation(data: any[] | undefined) {
    this.settleData = data ?? [];
  }
  @Mutation
  saveSettleDataJXSMutation(data: any[] | undefined) {
    this.settleDataJXS = data ?? [];
  }
  @Mutation
  saveSkuExpressMapMutation(data = {}) {
    this.skuExpressMap = Object.assign({}, this.skuExpressMap, data);
  }
  @Mutation
  clearSkuExpressMapMutation() {
    this.skuExpressMap = {};
  }

  // 更新item
  @Action
  async updateItemAction({
    checkOutStoreList = [],
    handlerFn = (allData: any[]) => allData
  }) {
    const { commit } = this.context;
    // const store = checkOutStoreList[0];
    //经销商商品
    const storeJXS = checkOutStoreList.find(item => item["cartType"] == "8");
    //佳通商品
    const storeJT = checkOutStoreList.find(item => item["cartType"] == "7");
    console.log(170, storeJT);
    commit("saveStoreInfoMutation", storeJT);

    // let allData = store?.checkOutProductList ?? [];

    let allDataJT = storeJT?.checkOutProductList ?? [];
    let allDataJXS = storeJXS?.checkOutProductList ?? [];
    // const payPromotionList = store?.payPromotionList ?? [];
    // // 赋值，添加，支付促销活动
    // if (payPromotionList?.length) {
    //   allData = allData.map(o => {
    //     (o.activityList ??= []).push(...payPromotionList);
    //     return o;
    //   });
    // }
    // 初始化商品数据，
    // allData = await this.formatListDataAction(allData);
    allDataJT = await this.formatListDataAction(allDataJT);
    allDataJXS = await this.formatListDataAction(allDataJXS);

    // 查询SKU express
    // allData = await handlerFn(allData);

    allDataJT = await handlerFn(allDataJT);
    // 全选字段赋值
    // commit(
    //   "saveAllSelectMutation",
    //   allData.filter(o => o.forSale).every(o => o._select)
    // );
    commit(
      "saveAllSelectJTMutation",
      allDataJT.filter(o => o.forSale).every(o => o._select)
    );
    commit(
      "saveAllSelectJXSMutation",
      allDataJXS.filter(o => o.forSale).every(o => o._select)
    );
    // 无效商品
    let InvalidListDataJT = allDataJT.filter(o => !o.forSale);
    let InvalidListDataJXS = allDataJXS.filter(o => !o.forSale);
    commit("saveInvalidListDataMutation", [
      ...InvalidListDataJT,
      ...InvalidListDataJXS
    ]);

    //
    const {
      state: { listDataJT, listDataJXS }
    } = this.context;
    // 售卖商品
    // allData = allData
    //   .filter(o => o.forSale)
    //   .map(item => {
    //     const prev = listData.find(o => o.skuCode === item.skuCode) || {};
    //     // 需要快递，默认false, 如果当前支持快递，就取上一次选择快递的结果。
    //     item._needExpress = (item._isExpress && prev._needExpress) || false;
    //     return item;
    //   });

    allDataJT = allDataJT
      .filter(o => o.forSale)
      .map(item => {
        const prev = listDataJT.find(o => o.skuCode === item.skuCode) || {};
        // 需要快递，默认false, 如果当前支持快递，就取上一次选择快递的结果。
        item._needExpress = (item._isExpress && prev._needExpress) || false;
        return item;
      });
    allDataJXS = allDataJXS
      .filter(o => o.forSale)
      .map(item => {
        const prev = listDataJXS.find(o => o.skuCode === item.skuCode) || {};
        // 需要快递，默认false, 如果当前支持快递，就取上一次选择快递的结果。
        // item._needExpress = (item._isExpress && prev._needExpress) || false;
        return item;
      });

    // commit("saveListDataMutation", allData);
    commit("saveListDataJTMutation", allDataJT);
    commit("saveListDataJXSMutation", allDataJXS);
    // return allData;
  }

  // 购物车列表
  @Action
  async initListAction() {
    const {
      productAmount,
      discount,
      actualPrice,
      checkOutStoreList = []
    } = await queryRequest({
      query: calculateCartWT,
      variables: {
        input: {
          payType: "云闪付" // 查询立减活动
        }
      }
    });
    const { commit } = this.context;
    // 优先清除skuExpressMap
    commit("clearSkuExpressMapMutation");

    commit("saveCartPriceMapMutation", {
      actualPrice,
      productAmount,
      discount
    });

    // 设置购物车的商品数量，最大 为限购的数量。
    // 当限购的数量 小于 购物车的商品数量， 需要更改。
    const newCheckOutStoreList: any[] = checkOutStoreList.map((item: any) => {
      item.checkOutProductList = item.checkOutProductList.map(o => {
        const originCount = o.count;
        o.count = o.quota ? Math.min(o.count, o.quota) : o.count;
        // 数量有变更，更新购物车
        if (o.count !== originCount) {
          this.context.dispatch("updateCartAction", {
            count: o.count,
            skuCode: o.skuCode,
            cartType: !(o.activityOrgCode !== "default") ? "7" : "8"
          });
        }
        return o;
      });
      return item;
    });
    await this.updateItemAction({
      checkOutStoreList: newCheckOutStoreList,
      handlerFn: this.querySkuHasExpress.bind(this)
    });
  }

  // 查询sku是否支持快递
  @Action
  async querySkuHasExpress(dataList) {
    // 查询sku是否支持快递
    const { list = [] } = await this.context.dispatch(
      "MallProductListModule/getSkuHasExpressAction",
      dataList.map(item => {
        return {
          skuCode: item.skuCode,
          pattern: item._pattern,
          specifications: item._specification
        };
      }),
      { root: true }
    );
    this.context.commit(
      "saveSkuExpressMapMutation",
      Object.assign({}, ...list.map(o => ({ [o.skuCode]: o.isExpress })))
    );

    // 设置 isExpress
    return await this.setSkuExpress(dataList);
  }

  // 设置 isExpress
  @Action
  setSkuExpress(data = []) {
    const {
      state: { skuExpressMap }
    } = this.context;
    return data.map(o => {
      o._isExpress = Boolean(+skuExpressMap[o.skuCode]);
      return o;
    });
  }

  // 初始化数据，需要快递默认false、格式化属性名
  @Action
  async formatListDataAction(data: any[]) {
    return cloneDeep(data).map(item => {
      // 格式化属性名
      item = formatProductData(item, true);
      item._select = item.selectFlag === "01" ? true : false;
      return item;
    });
  }

  // 初始化选中，默认false
  @Action
  initSelectAction({ flag = false, type = "" } = {}) {
    const {
      state: { listData, listDataJT, listDataJXS },
      commit
    } = this.context;
    if (type == "7") {
      commit(
        "saveListDataJTMutation",
        cloneDeep(listDataJT)
          // 初始化列表，选中默认false
          .map(item => {
            item._select = flag;
            return item;
          })
      );
    } else {
      commit(
        "saveListDataJXSMutation",
        cloneDeep(listDataJXS)
          // 初始化列表，选中默认false
          .map(item => {
            item._select = flag;
            return item;
          })
      );
    }
    // commit(
    //   "saveListDataMutation",
    //   cloneDeep(listData)
    //     // 初始化列表，选中默认false
    //     .map(item => {
    //       item._select = flag;
    //       return item;
    //     })
    // );
  }

  // 查询购物车数量 tbr
  @Action
  async getCartSkuAmountAction() {
    const { amount = 0 } = await queryRequest({
      query: getCartSkuAmount,
      variables: {
        input: {}
      }
    });
    this.context.commit("saveCartNumberMutation", amount);
  }

  // 删除购物车
  @Action
  async deleteCartAction(type) {
    const {
      state: { listData, listDataJT, listDataJXS },
      commit
    } = this.context;
    let deleteData = [];
    if (type === "7") {
      deleteData = listDataJT.filter(o => o._select);
    } else {
      deleteData = listDataJXS.filter(o => o._select);
    }
    // 删除的数据，默认是购物车选中的商品
    // let deleteData = data || listData.filter(o => o._select);
    const { success } = await queryRequest({
      query: deleteCartBySelected,
      variables: {
        input: {
          storeInputs: [
            {
              productInputList: deleteData.map(({ skuCode }) => ({
                selectFlag: "01",
                skuCode,
                ...GTGroupFixedOrgParam
              }))
            }
          ],
          cartType: type
        }
      }
    });
    // dispatch("getCartSkuAmountAction");
    // this.context.dispatch("initListAction");
    // 手动删除数据
    // commit(
    //   "saveListDataMutation",
    //   listData.filter(o => !o._select)
    // );
    if (type === "7") {
      commit(
        "saveListDataJTMutation",
        listDataJT.filter(o => !o._select)
      );
    } else {
      commit(
        "saveListDataJXSMutation",
        listDataJXS.filter(o => !o._select)
      );
    }

    return success;
  }

  // 添加购物车
  @Action
  async addCartAction({ skuCode = "", count = 1, cartType = "7" } = {}) {
    const { success } = await queryRequest({
      query: addCart,
      variables: {
        input: {
          skuCode: skuCode,
          count,
          cartType,
          ...GTGroupFixedOrgParam
        }
      }
    });
    // 添加购物车需要更新购物车数量
    this.context.dispatch("getCartSkuAmountAction");
    return success;
  }

  // 更新购物车
  @Action
  async updateCartAction(item: MallSku) {
    let res: boolean;
    try {
      const { success } = await queryRequest({
        query: updateCartSku,
        variables: {
          input: {
            ...item,
            ...GTGroupFixedOrgParam
            // ...GTGroupFixedParam
          }
        }
      });
      res = success;
    } catch (e) {
      console.log(e);
    }
    // 更新接口报错，也需要查询列表，更新购物车数据。
    // 这里需要等待更新购物车接口完成，因为计算接口，没有商品数量入参，后端自己查询的购物车商品数量。
    this.context.dispatch("calcCartAction");

    // this.context.dispatch("getCartSkuAmountAction");
    return res;
  }

  // 更新购物车2
  @Action
  async updateCartListAction(item: MallSku) {
    const { success } = await queryRequest({
      query: updateCartSkuList,
      variables: {
        input: {
          storeInputs: [
            {
              productInputList: [
                {
                  ...item,
                  ...GTGroupFixedOrgParam
                }
              ]
            }
          ],
          ...GTGroupFixedParam
        }
      }
    });
    this.context.dispatch("calcCartAction");
    // this.context.dispatch("getCartSkuAmountAction");
    return success;
  }
  // 删除购物车失效商品
  @Action
  async clearCartOffSale() {
    let { success } = await queryRequest({
      query: clearCartOffSale,
      variables: {}
    });
    // success &&
    this.context.commit("saveInvalidListDataMutation");
    console.log(success);
    return success;
  }

  // 计算购物车价格
  @Action
  async calcCartAction() {
    const {
      state: { listData, listDataJT, listDataJXS }
    } = this.context;
    const {
      actualPrice,
      discount,
      productAmount,
      checkOutStoreList
    } = await queryRequest({
      query: calculateCartWT,
      variables: {
        input: {
          storeInputs: [
            {
              cartType: "7",
              productInputList: listDataJT.map(({ skuCode, _select }) => ({
                selectFlag: _select ? "01" : "00",
                skuCode,
                ...GTGroupFixedOrgParam
              }))
            },
            {
              cartType: "8",
              productInputList: listDataJXS.map(({ skuCode, _select }) => ({
                selectFlag: _select ? "01" : "00",
                skuCode,
                ...GTGroupFixedOrgParam
              }))
            }
          ],
          payType: "云闪付" // 查询立减活动
        }
      }
    });
    const { commit } = this.context;
    commit("saveCartPriceMapMutation", {
      actualPrice,
      productAmount,
      discount
    });
    // 更新item
    await this.updateItemAction({
      checkOutStoreList,
      handlerFn: this.querySkuHasExpress.bind(this)
    });
  }

  // 结算购物车
  @Action
  async settleCartAction(express) {
    const {
      state: { listDataJT, listDataJXS }
    } = this.context;

    const inputList = [
      {
        cartType: "7",
        storeInputs: {
          productInputList: listDataJT
            .filter(o => o._select)
            .filter(o =>
              express >= 0 ? express === Number(o._needExpress) : true
            )
            .map(({ skuCode, _needExpress, _select, count }) => ({
              skuCode,
              isExpress: Number(_needExpress),
              selectFlag: _select ? "01" : "00",
              count,
              ...GTGroupFixedOrgParam
            }))
        }
      },
      {
        cartType: "8",
        storeInputs: {
          productInputList: listDataJXS
            .filter(o => o._select)
            .filter(o => true)
            .map(({ skuCode, _needExpress, _select, count }) => ({
              skuCode,
              isExpress: Number(_needExpress),
              selectFlag: _select ? "01" : "00",
              count,
              ...GTGroupFixedOrgParam
            }))
        }
      }
    ];
    try {
      let { checkOutStoreList } = await queryRequest({
        query: checkOutCartWt,
        variables: {
          input:
            express == 2
              ? inputList[1]
              : express >= 0
              ? inputList[0]
              : inputList.filter(o => o.storeInputs.productInputList.length > 0)
        }
      });

      const {
        state: { storeInfo }
      } = this.context;

      //经销商
      let checkOutStoreListJXS = [];
      checkOutStoreListJXS[0] = checkOutStoreList.find(
        item => item["cartType"] == "8"
      );
      // //佳通
      // const checkOutStoreListJT =
      //   checkOutStoreList[
      //     checkOutStoreList.findIndex(item => item["cartType"] == "7")
      //   ];

      const { address, storePhone, storeManagementName } =
        checkOutStoreList.find(
          o => o.isExpress === OrderExpressTypeEnums.EXPRESS
        ) || {};
      console.log(661, checkOutStoreList);
      this.context.commit(
        "saveStoreInfoMutation",
        Object.assign(storeInfo, { address, storePhone, storeManagementName })
      );

      let newCheckOutStoreList = [];
      for await (let item of checkOutStoreList) {
        if (item["cartType"] == "7") {
          item.checkOutProductList = item.checkOutProductList.map(sku =>
            formatProductData(sku)
          );
          // 设置skuExpress
          item.checkOutProductList = await this.setSkuExpress(
            item.checkOutProductList
          );
          newCheckOutStoreList.push(item);
        }
      }
      console.log(newCheckOutStoreList);
      // newCheckOutStoreList = checkOutStoreList.map(async item => {});
      this.context.commit("saveSettleDataMutation", newCheckOutStoreList);
      this.context.commit("saveSettleDataJXSMutation", checkOutStoreListJXS);
      return true;
    } catch (e) {
      this.context.dispatch("initListAction");

      return false;
    }
  }
}
